const Negociacao = () => import('../../spa/negociacao/Negociacao');
const NegociacaoList = () => import('../../spa/negociacao/NegociacaoList');
const DetalhesNegociacao = () => import('../../spa/negociacao/detalhes/DetalhesNegociacao');

export default {
  path: 'negociacao',
  component: Negociacao,
  children: [
    {
      path: '',
      name: 'negociacao',
      component: NegociacaoList,
    },
    {
      path: 'detalhes/fixo',
      name: 'detalhesNegociacaoFixo',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'FIXO',
        somenteLeitura: false,
        edicao: false,
      },
    },
    {
      path: 'detalhes/fixo/:id',
      name: 'verDetalhesNegociacaoFixo',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'FIXO',
        somenteLeitura: true,
        edicao: false,
      },
    },
    {
      path: 'detalhes/fixo/:id/fluxo',
      name: 'verDetalhesNegociacaoFixoFluxo',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'FIXO',
        somenteLeitura: true,
        edicao: false,
        fluxo: true,
      },
    },
    {
      path: 'detalhes/fixo/:id/editar',
      name: 'editarDetalhesNegociacaoFixo',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'FIXO',
        somenteLeitura: false,
        edicao: true,
      },
    },
    {
      path: 'detalhes/tabloide',
      name: 'detalhesNegociacaoTabloide',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'TABLOIDE',
        somenteLeitura: false,
        edicao: false,
      },
    },
    {
      path: 'detalhes/tabloide/:id',
      name: 'verDetalhesNegociacaoTabloide',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'TABLOIDE',
        somenteLeitura: true,
        edicao: false,
      },
    },
    {
      path: 'detalhes/tabloide/:id/fluxo',
      name: 'verDetalhesNegociacaoTabloideFluxo',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'TABLOIDE',
        somenteLeitura: true,
        edicao: false,
        fluxo: true,
      },
    },
    {
      path: 'detalhes/tabloide/:id/editar',
      name: 'editarDetalhesNegociacaoTabloide',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'TABLOIDE',
        somenteLeitura: false,
        edicao: true,
      },
    },
    {
      path: 'detalhes/negociacao_preco',
      name: 'detalhesNegociacaoPreco',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'NEGOCIACAO_PRECO',
        somenteLeitura: false,
        edicao: false,
      },
    },
    {
      path: 'detalhes/negociacao_preco/:id',
      name: 'verDetalhesNegociacaoPreco',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'NEGOCIACAO_PRECO',
        somenteLeitura: true,
        edicao: false,
      },
    },
    {
      path: 'detalhes/negociacao_preco/:id/fluxo',
      name: 'verDetalhesNegociacaoPrecoFluxo',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'NEGOCIACAO_PRECO',
        somenteLeitura: true,
        edicao: false,
        fluxo: true,
      },
    },
    {
      path: 'detalhes/negociacao_preco/:id/editar',
      name: 'editarDetalhesNegociacaoPreco',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'NEGOCIACAO_PRECO',
        somenteLeitura: false,
        edicao: true,
      },
    },
    {
      path: 'detalhes/positivacao',
      name: 'detalhesPositivacao',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'POSITIVACAO',
        somenteLeitura: false,
        edicao: false,
      },
    },
    {
      path: 'detalhes/positivacao/:id',
      name: 'verDetalhesPositivacao',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'POSITIVACAO',
        somenteLeitura: true,
        edicao: false,
      },
    },
    {
      path: 'detalhes/positivacao/:id/fluxo',
      name: 'verDetalhesPositivacaoFluxo',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'POSITIVACAO',
        somenteLeitura: true,
        edicao: false,
        fluxo: true,
      },
    },
    {
      path: 'detalhes/positivacao/:id/editar',
      name: 'editarDetalhesPositivacao',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'POSITIVACAO',
        somenteLeitura: false,
        edicao: true,
      },
    },
    {
      path: 'detalhes/crescimento',
      name: 'detalhesCrescimento',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'CRESCIMENTO',
        somenteLeitura: false,
        edicao: false,
      },
    },
    {
      path: 'detalhes/crescimento/:id',
      name: 'verDetalhesCrescimento',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'CRESCIMENTO',
        somenteLeitura: true,
        edicao: false,
      },
    },
    {
      path: 'detalhes/crescimento/:id/fluxo',
      name: 'verDetalhesCrescimentoFluxo',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'CRESCIMENTO',
        somenteLeitura: true,
        edicao: false,
        fluxo: true,
      },
    },
    {
      path: 'detalhes/crescimento/:id/editar',
      name: 'editarDetalhesCrescimento',
      component: DetalhesNegociacao,
      props: {
        tipoAcordo: 'CRESCIMENTO',
        somenteLeitura: false,
        edicao: true,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/negociacao.js